export const createElement = ({
  id,
  type,
  content = "",
  src = null,
  visible = true,
  styleRole,
  styles = {
    default: {},
    theme: {},
    custom: {},
  }
}) => ({
  id,
  type,
  content,
  src,
  visible,
  styleRole,
  styles
});

export const createCard = ({
  id,
  componentType,
  order = 0,
  visible = true,
  elements = [],
}) => ({
  id,
  componentType,
  order,
  visible,
  elements
});

export const createContainer = ({
  id,
  layoutRole = "column",
  order = 0,
  visible = true,
  cards = [],
}) => ({
  id,
  layoutRole,
  order,
  visible,
  cards
});

export const createSection = ({
  id,
  layoutRole = "default",
  visible = true,
  order = 0,
  containers = [],
}) => ({
  id,
  layoutRole,
  visible,
  order,
  containers
});

export const createPage = ({
  id = "page-1",
  name = "Untitled Page",
  sections = [],
}) => ({
  id,
  name,
  sections,
});


// page = {
//   sections: [
//     {
//       id: "section-hero",
//       layoutRole: "hero",
//       visible: true,
//       containers: [
//         {
//           id: "container-left",
//           layoutRole: "left",
//           order: 1,
//           visible: true,
//           cards: [
//             {
//               id: "card-hero-title",
//               componentType: "heroCard",
//               order: 1,
//               visible: true,
//               elements: [
//                 {
//                   id: "el-heading",
//                   type: "header",
//                   styleRole: "heading",
//                   content: "Welcome",
//                   visible: true,
//                   styles: {...}
//                 }
//               ]
//             }
//           ]
//         }
//       ]
//     }
//   ]
// }



// page.sections.forEach(section => {
//   section.layoutRole ||= "default";

//   section.contents.forEach(container => {
//     container.layoutRole ||= "column";
//     container.order ||= 0;

//     container.cards.forEach(card => {
//       card.componentType ||= "genericCard";
//       card.order ||= 0;

//       card.elements.forEach(el => {
//         el.styleRole ||= mapTypeToStyleRole(el.type);
//         el.visible ||= true;
//       });
//     });
//   });
// });